<template>
    <div>
        <b-alert v-model="showErrors" variant="danger" dismissible>
            <div v-for="(error, index) in errors" :key="index">
                <p>{{ error }}</p>
            </div>
        </b-alert>
        <ejs-grid id="printQueueGrid"
                  ref="printQueueGrid"
                  :dataSource="gridData"
                  :allowSorting="false"
                  :allowResizing="true"
                  :allowPaging="false"
                  :enableStickyHeader="true"
                  :queryCellInfo="customiseCell"
                  :detailTemplate="'detailTemplate'">
            <e-columns>
                <!-- :enablePersistence="true" -->

                <e-column field="workItemId" :headerText="'Work Item'" :template="'workItemColumnTemplate'" width="100"></e-column>

                <e-column field="hardCopyCount" :headerText="'# Orders'" width=15></e-column>
                <e-column field="fileName" :headerText="'File'" :template="'fileColumnTemplate'"></e-column>
            </e-columns>
            <template v-slot:workItemColumnTemplate="{data}">
                {{data.epiqNumber}} : {{data.matterDescription}}
            </template>
            <template v-slot:fileColumnTemplate="{data}">
                <div>
                    <a v-if="data.fileId != null" :href="fileDownloadUrl + data.fileId">{{data.fileName}}</a>
                    <span v-else>No File Available</span>
                </div>
            </template>

            <template v-slot:detailTemplate="{data}">
                <div>
                    {{data.courtInterviewOrganisation}} @ {{data.startTime}}



                    
                            <!--<ejs-grid :dataSource="data.printQueueOrders"
                                      :allowSorting="false"
                                      :allowResizing="true"
                                      :allowPaging="false">
                                <e-columns>
                                    <e-column field="orderNumber" :headerText="'Order #'" :template="'orderIdColumnTemplate'"></e-column>
                                    <e-column field="orderingClient" :headerText="'Ordering Client'"></e-column>
                                    <e-column field="copiesDelivered" :headerText="'Copies Delivered'" :template="'copiesDeliveredCT'"></e-column>
                                    <e-column field="deliveredOnTime" :headerText="'Delivered On Time?'" :template="'deliveredOnTimeCT'"></e-column>
                                    <e-column field="deliveredLateReason" :headerText="'Delivered Late Reason'" :template="'deliveredLateReasonCT'"></e-column>
                                    <e-column field="deliveredLateReasonText" :headerText="'Comments'" :template="'deliveredLateReasonTextCT'"></e-column>
                                    <e-column field="markDelivered" :headerText="'Mark Delivered'" :template="'markDeliveredColumnTemplate'"></e-column>
                                </e-columns>
                                <template v-slot:orderIdColumnTemplate="{data}">
                                    <a :href="orderBaseUrl + '/' + data.orderId">{{data.orderNumber}}</a>
                                </template>

                                <template v-slot:copiesDeliveredCT="{data}">
                                    <b-form-input :type="number" v-model="data.copiesDelivered"></b-form-input>
                                </template>

                                <template v-slot:deliveredOnTimeCT="{data}">
                                    <b-form-checkbox v-model="data.deliveredOnTime" switch></b-form-checkbox>
                                </template>

                                <template v-slot:deliveredLateReasonCT="{data}">
                                    <b-form-select v-model="data.deliveredLateReason" :options="deliveredLateOptions" :disabled="data.deliveredOnTime"></b-form-select>
                                </template>

                                <template v-slot:deliveredLateReasonTextCT="{data}">
                                    <b-form-input :type="text" v-model="data.deliveredLateReasonText" :disabled="data.deliveredOnTime"></b-form-input>
                                </template>

                                <template v-slot:markDeliveredColumnTemplate="{data}">
                                    <b-button size="sm" @click="markDelivered(data)">Mark Delivered</b-button>
                                </template>
                            </ejs-grid>-->
                       



                    <workitem-orders :api-base-url="apiBaseUrl"
                                     :work-item-id="data.workItemId"
                                     for-order-delivery
                                     v-model="data.ordersToBeDelivered"
                                     :can-view-turnarounds="true"
                                     :all-audio-sub-status-options="allAudioSubStatusOptions"
                                     :all-log-notes-sub-status-options="allLogNotesSubStatusOptions"
                                     :all-release-approval-sub-status-options="allReleaseApprovalSubStatusOptions"
                                     :all-deposit-sub-status-options="allDepositSubStatusOptions"
                                     :all-vetting-sub-status-options="allVettingSubStatusOptions"
                                     :all-delivered-late-reason-options="allDeliveredLateReasonOptions">
                    </workitem-orders>

                    <div class="w-100 d-flex justify-content-end">
                        <b-button class="mr-1" variant="warning" @click="markDelivered(data)">Mark Delivered (Cannot be undone!)</b-button>
                    </div>

                </div>
            </template>
        </ejs-grid>
    </div>
</template>

<script>
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    import axios from 'axios';
    import { GridPlugin, Edit, DetailRow } from '@syncfusion/ej2-vue-grids';

    import ErrorsMixin from '../mixins/ErrorsMixin';
    import DateTimeMixin from '../mixins/DateTimeMixin';
    import GridMixins from '../mixins/GridMixins';

    Vue.use(BootstrapVue);
    Vue.use(GridPlugin);


    export default {
        name: 'printQueue',
        mixins: [ErrorsMixin, DateTimeMixin, GridMixins],
        provide: {
            grid: [Edit, DetailRow]
        },
        props: {
            apiBaseUrl: {
                type: String,
                required: true
            },
            allAudioSubStatusOptions: {
                type: Array,
                default: null
            },
            allLogNotesSubStatusOptions: {
                type: Array,
                default: null
            },
            allReleaseApprovalSubStatusOptions: {
                type: Array,
                default: null
            },
            allDepositSubStatusOptions: {
                type: Array,
                default: null
            },
            allVettingSubStatusOptions: {
                type: Array,
                default: null
            },
            allDeliveredLateReasonOptions: {
                type: Array,
                default: null
            },
        },
        data: function () {
            return {
                selectionSettings: { checkboxOnly: true },
                editSettings: { allowEditing: true },
                showErrors: false,
                errors: [],
                busy: false,
                disabled: false,
                gridData: [],
                printQueueGrid: null,
                columnFormats: {
                    'startTime': {
                        type: 'datetime',
                        options: { outputAsUTC: true }
                    },
                    'createdDateTimeUTC': {
                        type: 'datetime',
                        options: { outputAsUTC: true }
                    },
                    'endTime': {
                        type: 'datetime',
                        options: { outputAsUTC: true }
                    },
                },
                fileDownloadUrl: null,
                orderBaseUrl: null,
                ordersToBeDelivered: null,
            };
        },
        methods: {
            resetModal: function () {
                this.gridData = [];
            },
            subdata: function (args, another) {
                this.args = args + another;

            },
            updateDisableCreate: function (uploadInProgress) {
                this.disabled = uploadInProgress;
            },
            customiseCell: function (args) {
                this.defaultEJ2DataGridQueryCellInfo(args, this.columnFormats);
            },
            getPrintQueueList: function () {
                this.busy = true;
                this.printQueueGrid.showSpinner();
                var url = this.$urlHelper.getApiUrl('PrintQueue', 'list');
                axios
                    .get(url)
                    .then((response) => {
                        this.gridData = response.data.result;
                        this.gridData = this.gridData.map((item) => {
                            item.ordersToBeDelivered = [];
                            return item;
                        });
                        this.busy = false;
                        this.printQueueGrid.hideSpinner();
                    })
                    .catch(ex => {
                        this.errors = this.handleAxiosException(ex);
                        this.showErrors = true;
                        this.busy = false;
                        this.printQueueGrid.hideSpinner();
                    });
            },
            markDelivered: function (args) {

                var data = { deliveredOrders: args.ordersToBeDelivered };

                var url = this.$urlHelper.getApiUrl('workitem', 'transcript', [args.workItemId, 'complete']);
                axios
                    .put(url, JSON.stringify(data),
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                    .then(() => {
                        this.getPrintQueueList();
                    })
                    .catch((ex) => {
                        this.errors = this.handleAxiosException(ex);
                        this.showErrors = true;
                    })

            },

        },
        mounted: function () {
            this.fileDownloadUrl = this.$urlHelper.getFileDownloadUrl("");
            this.orderBaseUrl = this.$urlHelper.getPageUrl("Orders", ["Edit"]);
            this.printQueueGrid = this.$refs.printQueueGrid.ej2Instances;
            this.defaultEJ2DataGridCreatedHandler(this.printQueueGrid);
            //printQueueGrid_vueComponent = this;

            setTimeout(() => {
                this.getPrintQueueList();
            }, 250);
            

        }

    }
</script>

